
import $ from 'jquery';

export default {
    win: $(window),
    doc: $(document),
    body: $('body'),
    header: $('header'),
    scrollbody: $('html, body'),
    sectionsWithDefinedColor: $('[data-text]')
};
